module.exports = __webpack_public_path__ + "static/media/refresh.b7c27cef.svg";